module.exports = __webpack_public_path__ + "img/primary-bg-bar.b576fd04.png";